import { permissionRegistry } from '@/core/registry';
import { ROLES } from '@/core/rbac';

/** Map Peace API role strings to app RBAC roles. */
export function mapPeaceRoleToAppRole(apiRole: string): string {
  const r = (apiRole || '').toLowerCase().replaceAll('-', '_');
  if (r === 'super_admin') return ROLES.SUPER_ADMIN;
  if (r === 'admin') return ROLES.NORMAL_ADMIN;
  return ROLES.NORMAL_USER;
}

const ADMIN_ALLOW_LIST = new Set([
  'dataset:read',
  'dataset:upload',
  'dataset:download',
  'document:read',
  'document:upload',
  'document:download',
  'document:delete',
  'graphs:read',
  'graphs:upload',
  'graph:read',
  'graph:upload',
  'case-studies:read',
  'case-studies:create',
  'case-studies:update',
  'case-studies:delete',
  'settings:read',
  'settings:update',
]);

function mergePermissions(base: string[], apiPermissions?: string[] | null): string[] {
  if (!apiPermissions?.length) return base;
  return [...new Set([...base, ...apiPermissions])];
}

/**
 * When the API omits a permissions array, derive UI permissions from role so guards keep working.
 * When the API returns permissions, merge them with role defaults so new features stay visible for admins.
 */
export function permissionsForPeaceUser(
  mappedRole: string,
  apiPermissions?: string[] | null
): string[] {
  const all = Object.values(permissionRegistry.getAll());

  if (mappedRole === ROLES.SUPER_ADMIN) {
    return mergePermissions(all, apiPermissions);
  }

  if (mappedRole === ROLES.NORMAL_ADMIN) {
    const derived = all.filter(p => ADMIN_ALLOW_LIST.has(p));
    return mergePermissions(derived, apiPermissions);
  }

  return apiPermissions?.length ? apiPermissions : [];
}
